"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePubkey = void 0;
const web3_js_1 = require("@solana/web3.js");
const react_1 = require("react");
const usePubkey = (raw) => {
    return (0, react_1.useMemo)(() => {
        if (!raw) {
            return null;
        }
        if (raw instanceof web3_js_1.PublicKey) {
            return raw;
        }
        try {
            return new web3_js_1.PublicKey(raw);
        }
        catch (e) {
            return null;
        }
    }, [raw]);
};
exports.usePubkey = usePubkey;
//# sourceMappingURL=usePubkey.js.map